import createAction from "./utils/createMetaAction";
import createMergedDefaultStateReducer from "./utils/createMergedDefaultStateReducer";
const initialSupportedTypes = {
  parts: true,
  features: true,
  translations: true,
  primers: true,
  cutsites: true,
  orfs: true,
  warnings: true,
  assemblyPieces: true,
  lineageAnnotations: true
};
export const annotationSupportToggle = createAction("annotationSupportToggle");
export const annotationSupportOn = createAction("annotationSupportOn");
export const annotationSupportOff = createAction("annotationSupportOff");
export default createMergedDefaultStateReducer(
  {
    [annotationSupportToggle]: (state, payload) => {
      return {
        ...state,
        [payload]: !state[payload]
      };
    },
    [annotationSupportOn]: (state, payload) => {
      return {
        ...state,
        [payload]: true
      };
    },
    [annotationSupportOff]: (state, payload) => {
      return {
        ...state,
        [payload]: false
      };
    }
  },
  initialSupportedTypes
);
